import { get, post, put } from '..'
import {
  ReselectMajor,
  CreateReselectMajorPayload
} from '@/models/Reselect/ReselectMajor'

export async function fetchReselectMajor() {
  const { data } = await get(`ReselectMajor/self`)
  return data as ReselectMajor
}

export async function updateReselectMajor(form: ReselectMajor) {
  const { data } = await put(`ReselectMajor/self`, form)
  return data as ReselectMajor
}

export async function createReselectMajor(form: CreateReselectMajorPayload) {
  const { data } = await post(`ReselectMajor/self`, form)
  return data as ReselectMajor
}
